import { createApp } from 'vue';
import App from './App.vue';
import { createI18n } from 'vue-i18n';
import router from '@/router';
import store from '@/store';
import ruLocale from '@/shared/locales/ru.json';
import enLocale from '@/shared/locales/en.json';
import esLocale from '@/shared/locales/es.json';
import ptLocale from '@/shared/locales/pt.json';
import clickOutside from '@/shared/directives/clickOutside';
import focus from '@/shared/directives/focus';

let currentLanguage = 'en';

try {
  const savedLanguage = localStorage.getItem('language');
  const language = savedLanguage || window.navigator.language;
  const userLanguage =
    language.includes('ru') ||
    language.includes('en') ||
    language.includes('es') ||
    language.includes('pt')
      ? language
      : 'en';
  currentLanguage = window.location.hostname === 'localhost' && !userLanguage ? 'ru' : userLanguage.slice(0, 2);
  localStorage.setItem('language', currentLanguage);
} catch (error) {
  console.error('Error setting language:', error);
}

const i18n = createI18n({
  legacy: true,
  locale: currentLanguage,
  fallbackLocale: 'en',
  messages: {
    ru: ruLocale,
    en: enLocale,
    es: esLocale,
    pt: ptLocale,
  },
});

const routers = router.createRouters();

const app = createApp(App);
app.directive('focus', focus);
app.directive('click-outside', clickOutside);
app.use(store);
app.use(routers);
app.use(i18n);
app.mount('#app');
